// Sorting callback function library. Since these functions are usually short, they
// can all be accommodated here. TODO: documentation

export function sortByKey(key: string) {
  if (key.startsWith('-')) {
    // sort descending by prepending a `-`
    key = key.slice(1);
    return (a, b) => a[key] > b[key] ? -1 : 1;
  } else {
    return (a, b) => a[key] > b[key] ? 1 : -1;
  }
}

export function sortAsc(a, b) {
  return a > b ? 1 : -1;
}

export function sortDesc(a, b) {
  return a > b ? -1 : 1;
}
